<template>
    <div class="container">

        <Fontnavbar title="申请售后" />

        <van-form @submit="onSubmit">

            <!-- 售后类型 -->
            <div class="order-goods">
                <van-cell>
                    <template slot="title">
                        <van-tag type="danger">必选</van-tag>
                        <span class="custom-title"> 售后类型</span>
                    </template>
                </van-cell>
                <div>
                    <van-field name="radio" label="">
                        <template #input>
                            <van-radio-group v-model="after_type" direction="horizontal">
                                <van-radio name="1">仅退款</van-radio>
                                <van-radio name="2">退货退款</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                </div>
            </div>

            <!-- 选择商品 -->
            <div class="order-goods">
                <van-cell>
                    <template slot="title">
                        <van-tag type="danger">必选</van-tag>
                        <span class="custom-title"> 选择商品</span>
                    </template>
                </van-cell>
                <div style="background-color: #ffffff;margin-bottom: 6px;margin-top: -10px;">
                    <van-row align="center" style="background-color: #ffffff;border-bottom: 1px solid #eee;" justify="space-around" v-for="(item, index) in order.goods" :key="index">
                        <van-col offset="2" span="20">
                            <van-checkbox v-model="item.is_select" icon-size="24px" checked-color="#ee0a24" label-disabled @change="select(index)" ref="checkbox">
                                <van-card
                                        style="background-color: #ffffff;"
                                        :title="item.goods_name"
                                        :thumb="imgDomain + item.goods_thumb_path"
                                        :centered="true"
                                >
                                    <template #tags>
                                        <van-tag class="points-tag" style="margin: 10px auto;" size="medium" plain type="warning">￥{{ item.goods_price}}</van-tag>
                                        <br/>
                                        <van-stepper v-model="item.select_number" :async-change="true" :max="item.goods_num" theme="round" :name="index" button-size="22" disable-input @change="changeNumber" />
                                    </template>
                                </van-card>
                            </van-checkbox>
                        </van-col>
                        <van-divider />
                    </van-row>
                </div>
            </div>

            <!-- 图片信息 -->
            <div class="order-goods">
                <van-cell>
                    <template slot="title">
                        <van-tag type="success">可选</van-tag>
                        <span class="custom-title"> 图片信息</span>
                    </template>
                </van-cell>
                <div>
                    <van-field name="uploader" label="">
                        <template #input>
                            <van-uploader v-model="images" multiple :max-count="9" :after-read="afterRead" :before-delete="beforeDelete"  />
                        </template>
                    </van-field>
                </div>
            </div>

            <!-- 退款原因 -->
            <div class="order-goods">
                <van-cell>
                    <template slot="title">
                        <van-tag type="success">可选</van-tag>
                        <span class="custom-title"> 退款原因</span>
                    </template>
                </van-cell>
                <div>
                    <van-field
                            v-model="refund_reason"
                            rows="2"
                            autosize
                            label=""
                            type="textarea"
                            maxlength="255"
                            placeholder="请输入退款原因"
                            show-word-limit
                    />
                </div>
            </div>

            <!-- 退款金额 -->
            <div class="order-goods">
                <van-cell>
                    <template slot="title">
                        <van-tag type="success">可选</van-tag>
                        <span class="custom-title"> 退款金额</span>
                    </template>
                </van-cell>
                <div>
                    <van-field v-model="refund_money" @input="changeMoney" type="number" label="" />
                </div>
            </div>

            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">确认</van-button>
            </div>
        </van-form>

    </div>
</template>

<script>
    import { orderDetail, uploadFile, order_after } from '@/api.js'
    import { post, postForm } from '@/request.js'
    import {
        Button, Card,
        Cell,
        CellGroup, Checkbox, CheckboxGroup,
        Col,
        Dialog, Divider, GoodsAction, GoodsActionButton, GoodsActionIcon,
        Icon,
        Image,
        Loading, Radio, RadioGroup,
        Row,
        Stepper,
        Swipe,
        SwipeItem,
        Tag,
        Form,
        Uploader,
        Toast,
        Field
    } from "vant";
    import Fontnavbar from "../../components/Navbar";
    export default {
        name: "apply",
        components: {
            [Loading.name]: Loading,
            [Image.name]: Image,
            [Tag.name]: Tag,
            [Col.name]: Col,
            [Icon.name]: Icon,
            [Button.name]: Button,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Swipe.name]: Swipe,
            [Stepper.name]: Stepper,
            [SwipeItem.name]: SwipeItem,
            [GoodsAction.name]: GoodsAction,
            [GoodsActionIcon.name]: GoodsActionIcon,
            [GoodsActionButton.name]: GoodsActionButton,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Card.name]: Card,
            [Divider.name]: Divider,
            [Form.name]: Form,
            [Field.name]: Field,
            [Uploader.name]: Uploader,
            [Toast.name]: Toast,
            Fontnavbar,
        },
        data(){
            return {
                imgDomain: process.env.VUE_APP_IMG_URL,
                order:{}, //订单信息
                after_type:'', //售后类型
                images:[], //图片信息
                refund_reason:'', //退款原因
                refund_money:0, //实际退款金额
                params:{
                    goods_id:[],
                    goods_num:{},
                    file:[],
                },//提交参数
            }
        },
        mounted() {
            this.getInitData(this.$route.query.order_no); //获取初始化数据
        },
        computed: {
            // 最大退款金额
            max_money: function() {
                let number = 0;
                var goods = this.order.goods ? this.order.goods : [];
                goods.forEach(function (v) {
                    if (v.is_select){
                        number += v.select_number * v.goods_price
                    }
                });
                return number.toFixed(2);
            }
        },
        methods: {
            // 获取初始化数据
            getInitData(order_no){
                post(orderDetail, {order_no:order_no}).then((res) => {
                    if (res.code == 200) {
                        res.data.goods.forEach(function (v, i) {
                            res.data.goods[i].is_select = 0;
                            res.data.goods[i].select_number = 1;
                        })
                        this.order = res.data
                    } else if (res.code == 201) {
                        Dialog({ message: '您当前未登录' })
                        setTimeout(() => {
                            this.$router.replace({ path: '/user/login' })
                        }, 1000)
                    } else {
                        Dialog({ message: res.msg }).then(() => {
                            this.$router.replace({ path: '/user/index' })
                        })
                    }
                })
            },
            // 选择商品
            select(){
                this.refund_money = this.max_money
            },
            // 改变数量
            changeNumber(){
                this.refund_money = this.max_money
            },
            // 改变金额
            changeMoney (newVal) {
                let max = parseFloat(this.max_money)
                newVal = parseFloat(newVal)
                if (newVal > max){
                    Toast('退款金额不能超出订单总金额');
                    this.refund_money = max
                }
            },
            // 文件上传完毕后会触发的回调函数，获取到对应的 file 对象
            afterRead(file) {
                let that = this;
                if (file.length > 1){
                    file.forEach(function (item) {
                        // 此时可以自行将文件上传至服务器
                        item.status = 'uploading';
                        item.message = '上传中...';
                        var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
                        formData.append('file', item.file); //接口需要传的参数
                        postForm(uploadFile, formData).then((res) => {
                            if (res.code == 200) {
                                item.status = 'done';
                                item.message = '上传完成';
                                that.params.file.push(res.data)
                            } else {
                                item.status = 'failed';
                                item.message = '上传失败';
                            }
                        })
                    })
                } else {
                    // 此时可以自行将文件上传至服务器
                    file.status = 'uploading';
                    file.message = '上传中...';
                    var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
                    formData.append('file', file.file); //接口需要传的参数
                    postForm(uploadFile, formData).then((res) => {
                        if (res.code == 200) {
                            file.status = 'done';
                            file.message = '上传完成';
                            that.params.file.push(res.data)
                        } else {
                            file.status = 'failed';
                            file.message = '上传失败';
                        }
                    })
                }
            },

            //文件删除前的回调函数，返回 false 可终止文件读取，支持返回 Promise
            beforeDelete(file, info){
                this.params.file.splice(info.index, 1);
                return true;
            },

            // 提交
            onSubmit(){
                var row = this.getRowData();
                if (row){
                    post(order_after, row).then((res) => {
                        if (res.code == 200) {
                            Dialog({ message: res.msg }).then(() => {
                                this.$router.replace({ path: '/service/servicelist' })
                            })
                        } else if (res.code == 201) {
                            Dialog({ message: '您当前未登录' })
                            setTimeout(() => {
                                this.$router.replace({ path: '/user/login' })
                            }, 1000)
                        } else {
                            Dialog({ message: res.msg }).then(() => {
                                this.$router.replace({ path: '/user/index' })
                            })
                        }
                    })
                }
            },
            // 获取提交的数据
            getRowData(){
                if (this.after_type.length < 1){
                    Toast('请选择售后类型');
                    return false;
                }
                var params = {
                    goods_id:[],
                    goods_num:{},
                }
                params.order_no = this.order.order_no;
                params.order_id = this.order.id;
                params.after_type = this.after_type;
                params.refund_reason = this.refund_reason;
                params.refund_money = this.refund_money ? this.refund_money : this.max_money;
                params.file = this.params.file;

                this.order.goods.forEach(function (v) {
                    if (v.is_select){
                        params.goods_id.push(v.goods_id)
                        params.goods_num[v.goods_id] = v.select_number
                    }
                });
                if (params.goods_id.length < 1){
                    Toast('请勾线商品');
                    return false;
                }
                this.params = params;
                return params;
            }
        }
    }
</script>

<style scoped>

</style>